module.exports = __webpack_public_path__ + "img/vetor-login.90436d1a.png";